// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__PKrRZ","validationTips":"StatementDescriptor_validationTips__29PSW"};